import { Controller } from "@hotwired/stimulus"

// A minimal "add/remove a nested form row" controller for organizations/on_call_schedules/_form.html.erb's
// own rotation-slot picker (accepts_nested_attributes_for :on_call_schedule_members). Adding
// clones the <template>, swapping the standard Rails NEW_RECORD placeholder (see the form's own
// child_index: "NEW_RECORD") for a unique index so each new row's inputs get distinct
// name/id attributes. Removing an unpersisted row just deletes it from the DOM outright: it was
// never going to be submitted as anything but blank anyway; an already-persisted row instead uses
// a plain visible _destroy checkbox rendered by the form itself (no JS involved), since Rails
// needs that row still present and marked for destruction on submit, not removed from the DOM.
export default class extends Controller {
  static targets = ["container", "template", "field"]

  add() {
    const uniqueIndex = Date.now()
    const content = this.templateTarget.content.cloneNode(true)

    content.querySelectorAll("[name], [id]").forEach((element) => {
      if (element.name) element.name = element.name.replace("NEW_RECORD", uniqueIndex)
      if (element.id) element.id = element.id.replace("NEW_RECORD", uniqueIndex)
    })

    this.containerTarget.appendChild(content)
  }

  remove(event) {
    event.target.closest("[data-nested-fields-target='field']").remove()
  }
}
